// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"163":"60ebe880","415":"fef3aa6c","606":"e72e85f0","941":"52976e56"}[chunkId] + ".chunk.css";
};